import React from 'react';
import { CheckIcon } from 'lucide-react';
const points = ['Natychmiastowy dostęp', 'Bez specjalnych zestawów', 'Łatwe → Z podpowiedzią → Wyzwanie'];
export function TrustBar() {
  return <section className="w-full bg-secondary px-5 py-8" data-id="element-233" data-mp="y9ii6al8jluo">
      <ul className="mx-auto flex max-w-3xl flex-col items-center justify-center gap-3 text-center sm:flex-row sm:gap-8" data-id="element-234" data-mp="y6mnqw8ljfaz">
        {points.map(point => <li key={point} className="flex items-center gap-2" data-id="element-235" data-mp="1qyfxq5y2b4jq">
            <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-success/15 text-success" data-id="element-236" data-mp="1uyq6trh5ib2t">
              <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-237" data-mp="1h007s6aru1bt" />
            </span>
            <span className="text-sm font-semibold text-foreground" data-id="element-238" data-mp="1lxs9tt54r3tq">{point}</span>
          </li>)}
      </ul>
    </section>;
}